export const GlobalFilter = ({ filter, setFilter, placeholder }) => {
  return (
    <input
      value={filter || ""}
      className="p-2 col-md-12 search-box"
      onChange={(e) => setFilter(e.target.value)}
      placeholder={placeholder}
    />
  );
};
